import React from "react";
import {
  BookmakerDTO,
  BookmakerRunnerDTO,
  EventDTO,
  isBmSpecialMarket,
  useAppSelector,
} from "@hypexone/uicore";
import { isMobile } from "react-device-detect";
import EventMarketButton from "../../events/EventMarketButton";
import BetSlip from "../BetSlip";
import BookmakerBackAndLay from "./BookmakerBackAndLay";

interface BookmakerRowProps {
  exposureMap: any;
  cFactor: number;
  runner: BookmakerRunnerDTO;
  market: BookmakerDTO;
  eventData: EventDTO;
  index: number;
  setBetStartTime?: Function;
  setAddNewBet?: Function;
  hideLay?: boolean;
}

const BookmakerRow: React.FC<BookmakerRowProps> = ({
  exposureMap,
  cFactor,
  runner,
  market,
  eventData,
  index,
  setAddNewBet,
  setBetStartTime,
  hideLay = false,
}) => {
  const {
    bets,
    isOneClickBettingEnabled,
    // openBets
  } = useAppSelector((state) => state.betSlip);

  const disabledStatus = [
    "suspended",
    "closed",
    "suspended-manually",
    "ball_running",
  ];
  const showSuspendedOverlay =
    disabledStatus.includes(runner.status?.toLowerCase()) ||
    eventData?.eventSuspended === true ||
    market.suspend === true;
  const backColSpan = hideLay ? (isMobile ? 2 : 5) : isMobile ? 1 : 3;
  const slipColSpan = hideLay ? (isMobile ? 2 : 6) : isMobile ? 3 : 7;

  const getOpenBetsPL = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => {
    if (exposureMap && exposureMap?.[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn?.userRisk / cFactor;
        }
      }
    }
  };

  const getOpenBetsPLInArray = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => {
    let pl = getOpenBetsPL(runner, marketId, marketName);
    return pl ? [pl] : [];
  };

  const getTotalPL = (
    runner: BookmakerRunnerDTO,
    marketId: string,
    marketName: string
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketId === marketId && b.amount && b.amount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(runner, marketId, marketName);
      for (let bet of mBetslipBets) {
        if (bet.oddValue) {
          let plVal = (bet.oddValue / 100 + 1) * bet.amount - bet.amount;
          if (isBmSpecialMarket(bet.marketName, bet.oddType)) {
            plVal = (bet.oddValue - 1) * bet.amount; 
          }
          if (bet.betType === "BACK") {
            if (bet.outcomeId === runner.runnerId)
              returns ? (returns += plVal) : (returns = plVal);
            else returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
          } else if (bet.betType === "LAY") {
            if (bet.outcomeId === runner.runnerId)
              returns ? (returns -= plVal) : (returns = 0 - plVal);
            else returns ? (returns += bet.amount) : (returns = bet.amount);
          }
        }
      }
    }
    return [returns];
  };

  return (
    <>
      <tr className=" border-b  border-b-gray13 h-[43px] w-full">
        <td className="text-start pl-2 w-[60%] md:w-[40%] h-[43px]">
          <div className="flex items-center gap-1 h-full">
            <div className="flex items-center h-full">
              <span className=" text-[12px] font-[700] font-sans">
                {market.marketName === 'Genie Combo Special Bet' ? (
                  <div className="flex flex-col">
                    {runner?.runnerName?.split(';').map((part, idx) => (
                      <span key={idx}>{part}</span>
                    ))}
                  </div>
                ) : (
                  <span>{runner?.runnerName}</span>
                )}
              </span>
              {getOpenBetsPLInArray(
                runner,
                market.marketId,
                market.marketName
              ).map((ret, idx2) =>
                ret !== null ? (
                  <span
                    key={idx2}
                    className={
                      ret >= 0 ? " text-[#1b891b] " : " text-[#ff3a3a] "
                    }
                  >
                    {ret > 0
                      ? "+" + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
              )}
            </div>
            <div>
              {bets.length > 0 && bets[0].amount > 0 ? (
                <div>
                  {getTotalPL(runner, market.marketId, market.marketName).map(
                    (ret, idx3) =>
                      ret && ret !== null ? (
                        <span
                          key={idx3}
                          className={
                            ret >= 0 ? " text-[#1b891b] " : " text-[#ff3a3a] "
                          }
                        >
                          {ret > 0
                            ? "+" + Number(ret).toFixed(2)
                            : Number(ret).toFixed(2)}
                        </span>
                      ) : null
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </td>
        <td
          className={`h-[43px] ${hideLay ? "w-[40%] md:w-[60%] relative" : "w-[20%] md:w-[30%]"}`}
          colSpan={backColSpan}
        >
          <div className="hidden md:flex h-full">
            <EventMarketButton oddType="back-odd" customBgColor="bg-blue15" />
            <EventMarketButton oddType="back-odd" customBgColor="bg-blue16" />
            <BookmakerBackAndLay
              runner={runner}
              market={market}
              eventData={eventData}
              oddType="back-odd"
              disabledStatus={disabledStatus}
            />
          </div>
          <div className="flex md:hidden h-full">
            <BookmakerBackAndLay
              runner={runner}
              market={market}
              eventData={eventData}
              oddType="back-odd"
              disabledStatus={disabledStatus}
            />
          </div>
          {hideLay && showSuspendedOverlay ? (
            <div
              className="absolute inset-0 bg-black bg-opacity-25 z-10 flex items-center justify-center pointer-events-none"
              key={"row-" + index + "cell-4"}
            >
              <span className="text-white font-sans text-[13px]">
                Suspended
              </span>
            </div>
          ) : null}
        </td>
        {!hideLay ? (
          <td
            className="w-[20%] md:w-[30%] h-[43px] relative"
            colSpan={isMobile ? 1 : 3}
          >
            <div className="hidden md:flex h-full">
              <BookmakerBackAndLay
                runner={runner}
                market={market}
                eventData={eventData}
                oddType="lay-odd"
                disabledStatus={disabledStatus}
              />
              <EventMarketButton oddType="lay-odd" customBgColor="bg-pink2" />
              <EventMarketButton oddType="lay-odd" customBgColor="bg-pink3" />
            </div>
            <div className="flex md:hidden h-full">
              <BookmakerBackAndLay
                runner={runner}
                market={market}
                eventData={eventData}
                oddType="lay-odd"
                disabledStatus={disabledStatus}
              />
            </div>
            {showSuspendedOverlay ? (
              <div
                className="absolute top-0 bottom-0 left-[-100%] w-[200%] bg-black bg-opacity-25 z-10 flex items-center justify-center pointer-events-none"
                key={"row-" + index + "cell-5"}
              >
                <span className="text-white font-sans text-[13px]">
                  Suspended
                </span>
              </div>
            ) : null}
          </td>
        ) : null}

      </tr>

      {!isOneClickBettingEnabled &&
        bets?.length > 0 &&
        bets?.[0]?.marketName === market.marketName &&
        bets?.[0]?.marketId === market.marketId &&
        bets?.[0]?.outcomeId === runner?.runnerId && (
          <tr>
            <td colSpan={slipColSpan}>
              <BetSlip
                eventData={eventData}
                setBetStartTime={(date) => setBetStartTime(date)}
                setAddNewBet={(val) => setAddNewBet(val)}
              />
            </td>
          </tr>
        )}
    </>
  );
};

export default BookmakerRow;
